import React, { useState, useEffect, useRef } from 'react'
import { useSpring, animated as a, useChain } from 'react-spring'

// SVGs
import HackerSVG from '../../svg/hacker.svg'

// Component
const About = ({ isVisible }) => {
  // Load/View detection
  const [loaded, setLoaded] = useState(false)

  const load = isVisible => {
    if (isVisible && !loaded) {
      setLoaded(true)
    }
  }

  useEffect(() => {
    load(isVisible)
  }, [isVisible])

  // Animations
  const spring1 = useRef()
  const spring2 = useRef()

  const { opacity } = useSpring({
    from: {
      opacity: 0,
    },
    to: {
      opacity: 1,
    },
    ref: spring2,
  })

  const { width } = useSpring({
    from: {
      width: 0,
    },
    to: {
      width: 95,
    },
    ref: spring1,
  })

  useChain(loaded ? [spring1, spring2] : [], [0, 0.2])

  return (
    <div name="about" id="about" className="about">
      <div className="about-head">
        <h1>About</h1>
        <a.hr
          className="about-under"
          style={{ width: width.interpolate(width => `${width}%`) }}
        />
      </div>
      <a.div
        className="about-inner"
        style={{
          opacity,
        }}
      >
        <div className="about-paras">
          <p>
            I am a Web Developer. I aim to create fast, convenient and
            accessible web apps. I focus on writing maintainable code, creating
            easily usable user-interfaces and employing good UI/UX practices to
            make it all look appealling.
          </p>

          <p>
            I like to keep up with the latest trends in the field, and like to
            experiment with new technologies. Apart from webdev, I am interested
            in the field of Data Science and Machine Learning and also have good
            Software Engineering skills. Learning is what keeps me interested.
          </p>
        </div>
        <div style={{ opacity }} className="about-illus">
          <HackerSVG />
        </div>
      </a.div>
    </div>
  )
}

export default About
